"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/CaptionPart.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





var _message = require('shared/enum/message');
var _RichMessageWrapper = require('../RichMessageWrapper');
var _ReactionChips = require('../RichMessageWrapper/ReactionChips'); var _ReactionChips2 = _interopRequireDefault(_ReactionChips);
var _TextMessage = require('../TextMessage');
var _ui = require('web/services/ui');

/* Text sent with a file, or with a group of images, as one message: the
 * caption's own message, drawn in the same bubble. */










const CAPTION_PART = { [_RichMessageWrapper.MESSAGE_PART_ATTRIBUTE]: '' }

/* The caption as a RichMessageWrapper `part`: while the pointer is over it,
 * the row's hover buttons and menu act on the caption's own message. */
 const useCaptionPart = (
  caption,
  deleted,
  onReplyCaption,
) => {
  const captionText = _optionalChain([caption, 'optionalAccess', _ => _.MessageText])
  const handleCopyCaption = _react.useCallback.call(void 0, 
    () => _ui.copyToClipboard.call(void 0, captionText || ''),
    [captionText],
  )
  const captionKey = _optionalChain([caption, 'optionalAccess', _2 => _2.MessageKey])
  const captionStatus = _optionalChain([caption, 'optionalAccess', _3 => _3.deliveryStatus]) || _message.deliveryStatus.DELIVERED
  return _react.useMemo(
    () => captionKey && !deleted
      ? {
          messageKey: captionKey,
          deliveryStatus: captionStatus,
          onCopy: handleCopyCaption,
          onReply: onReplyCaption,
        }
      : undefined,
    [captionKey, deleted, captionStatus, handleCopyCaption, onReplyCaption],
  )
}; exports.useCaptionPart = useCaptionPart












/* The caption's text and its own reactions, marked as the wrapper's part. */
const CaptionPart = ({
  caption,
  className,
  currentUserKey,
  subscribers,
  conversationKey,
  onAddReaction,
  onRemoveReaction,
  readOnly,
}) => (
  _react2.default.createElement('div', { className: className, ...CAPTION_PART, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
    , _react2.default.createElement(_TextMessage.MessageBody, {
      text: caption.MessageText,
      mentions: caption.Mentions,
      currentUserKey: currentUserKey,
      subscribers: subscribers, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
    )
    , _react2.default.createElement(_ReactionChips2.default, {
      reactions: caption.Reactions,
      currentUserKey: currentUserKey,
      messageKey: caption.MessageKey,
      conversationKey: conversationKey,
      deleted: false,
      subscribers: subscribers,
      onAddReaction: onAddReaction,
      onRemoveReaction: onRemoveReaction,
      readOnly: readOnly, __self: this, __source: {fileName: _jsxFileName, lineNumber: 83}}
    )
  )
)

exports. default = CaptionPart
